import {Field} from 'formik';
import {Alert, Group, Stack} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {
    FlexiDeleteButton,
    FormikSelect,
    FormikTextInput,
    PlatformFieldset,
} from '@flexinet/ui-components';

import {PriceRows} from './PriceRows';
import {USAGE_UNAVAILABLE_MESSAGE} from './RecordSchema';
import {DIMENSION_KINDS, DimensionFormValues} from '../types';

const KIND_LABELS: Record<string, string> = {
    FLAT: 'Flat',
    CONTRACT: 'Contract',
    USAGE: 'Usage',
};

const kindOptions = () => DIMENSION_KINDS.map(kind => ({value: kind, label: I18n.get(KIND_LABELS[kind])}));

type DimensionFieldsProps = {
    index: number,
    dimension: DimensionFormValues,
    onRemove: () => void,
};

export const DimensionFields = ({index, dimension, onRemove}: DimensionFieldsProps) => (
    <PlatformFieldset legend={`${I18n.get('Pricing unit')} ${index + 1}`}>
        <Stack>
            <Group justify='flex-end'>
                <FlexiDeleteButton
                    size='xs'
                    aria-label={`${I18n.get('Remove pricing unit')} ${index + 1}`}
                    onClick={(e) => {
                        e.preventDefault();
                        onRemove();
                    }}
                >
                    {I18n.get('Remove')}
                </FlexiDeleteButton>
            </Group>
            <Field
                name={`dimensions.${index}.name`}
                label={I18n.get('Name')}
                component={FormikTextInput}
                withAsterisk
            />
            <Field
                name={`dimensions.${index}.unit`}
                label={I18n.get('Unit')}
                description={I18n.get('What one unit counts, for example seat or request')}
                component={FormikTextInput}
                withAsterisk
            />
            <Field
                name={`dimensions.${index}.kind`}
                label={I18n.get('Kind')}
                component={FormikSelect}
                data={kindOptions()}
                allowDeselect={false}
                withAsterisk
            />
            <Field
                name={`dimensions.${index}.description`}
                label={I18n.get('Description')}
                component={FormikTextInput}
            />
            {dimension.kind === 'USAGE' ? (
                // Shown the moment USAGE is chosen, not after a failed submit:
                // the operator should not fill in prices for a unit that cannot
                // be saved. The schema blocks the submit as well.
                <Alert color='red' title={I18n.get('Usage pricing is not available')}>
                    {I18n.get(USAGE_UNAVAILABLE_MESSAGE)}
                </Alert>
            ) : (
                <PriceRows index={index} dimension={dimension}/>
            )}
        </Stack>
    </PlatformFieldset>
);
